// extracted by mini-css-extract-plugin
module.exports = {"Input":"Input_Input__3wQeg","Label":"Input_Label__gwonN","InputElement":"Input_InputElement__37zLK","Invalid":"Input_Invalid__kIKVc"};